import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { s as slotFilled } from './index3.js';
import { d as defineCustomElement$4 } from './box.js';
import { d as defineCustomElement$3 } from './icon.js';
import { d as defineCustomElement$2 } from './tooltip.js';
import { d as defineCustomElement$1 } from './tooltip-label.js';

const formFieldCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:flex;flex-direction:column;font-family:Open Sans;font-size:.875rem;font-weight:400;gap:.25rem;height:100%;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;position:relative;width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host([size=lg]) label>h3{color:var(--jw-theme-form-field-filled-color);font-family:Open Sans;font-size:1.125rem;font-weight:400;letter-spacing:-.0008em;line-height:1.5rem;margin:0}label{display:flex;flex-direction:column;gap:.25rem;height:100%;width:100%}.label{color:var(--jw-theme-form-label-color);display:flex;font-family:Open Sans;font-size:.875rem;font-weight:600;letter-spacing:-.0004em;line-height:1.25rem}.label span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.label .required-asterisk{color:var(--jw-theme-form-validation-error-color);margin-left:.125rem}.label .optional-text{color:var(--jw-theme-form-field-placeholder-color);font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;margin-left:.25rem}.label wui-tooltip{align-self:center;margin-left:.25rem}.description{color:var(--jw-theme-form-validation-default-color);display:flex;justify-content:space-between;margin-left:var(--form-field--description-left,0);transition:color .3s ease}.description span{font-family:Open Sans;font-size:.75rem;font-weight:400;letter-spacing:0;line-height:1rem}.description.error{color:var(--jw-theme-form-validation-error-color)}.description.warning{color:var(--jw-theme-form-validation-warning-color)}";
const WuiFormFieldStyle0 = formFieldCss;

const WuiFormField = /*@__PURE__*/ proxyCustomElement(class WuiFormField extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.label = undefined;
        this.description = undefined;
        this.helperText = undefined;
        this.tooltip = undefined;
        this.requisite = undefined;
        this.errorMessage = undefined;
        this.errorType = 'error';
        this.size = 'md';
        this.value = '';
        this.disabled = false;
    }
    renderDescription() {
        if (!(this.errorMessage || typeof this.description === 'string' || slotFilled(this.el, 'post-description'))) {
            return;
        }
        return (h("div", { class: 'description' + (this.errorMessage && this.errorType ? ` ${this.errorType}` : '') }, h("wui-box", { align: "start", gutter: "2xs", orientation: "horizontal", justify: "center" }, this.errorMessage && (h("wui-icon", { name: this.errorType === 'error' ? 'alert-circle-filled' : 'alert-triangle-filled' })), h("span", null, this.errorMessage || (typeof this.description === 'string' ? this.description : ''))), h("slot", { name: "post-description" })));
    }
    render() {
        return (h(Host, { key: 'a3e797837ebc8e07a066e9af5f4cd90c4a8abfe2' }, h("label", { key: '58decda803d6920b061adff4902ec0392d93aad0', "aria-hidden": !this.label }, typeof this.label === 'string' && (h("div", { key: '2bbe05be4fc94255465c26eaaedef0a5fba3526f', class: "label" }, h("span", { key: 'a246733e56fcc8005a081a025a8eb49223d37987' }, this.label || '\u200B'), this.requisite === 'required' && h("span", { key: '594b169bfb436e94ada4dcc508b29162ab95438f', class: "required-asterisk" }, "*"), this.requisite === 'optional' && h("span", { key: '9d6be395573ed98a62747ecf8c65f63429f79329', class: "optional-text" }, "(Optional)"), this.tooltip && (h("wui-tooltip", { key: '986ef405c7b3bb4cf7d11a5816b808b1b1c7988a', label: this.tooltip }, h("wui-icon", { key: 'd331273e3b29b52bc1fa9a356839548c1e1df3f7', name: "help-filled" }))))), this.helperText && (h("div", { key: 'c565e44576a0e7eab16ce3ccd1c15620b3eca603', class: "description" }, h("wui-box", { key: '14fe5416491ff32a200c1ddeed248e416eb36958', align: "start", gutter: "2xs", orientation: "horizontal", justify: "center" }, h("span", { key: '685ff7bf82f0fa26d5ca4ce56b3b12279da2f4ab' }, this.helperText)))), this.size === 'lg' ? h("h3", null, this.value) : h("slot", null)), this.renderDescription()));
    }
    get el() { return this; }
    static get style() { return WuiFormFieldStyle0; }
}, [1, "wui-form-field", {
        "label": [1],
        "description": [1],
        "helperText": [1, "helper-text"],
        "tooltip": [1],
        "requisite": [1],
        "errorMessage": [1, "error-message"],
        "errorType": [1, "error-type"],
        "size": [513],
        "value": [1],
        "disabled": [516]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-form-field", "wui-box", "wui-icon", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiFormField);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiFormField as W, defineCustomElement as d };

//# sourceMappingURL=form-field.js.map